export default __webpack_public_path__ + "static/media/mapbook-primero.3912298f.jpg";